<!--
 * @Author: Gaho
 * @Date: 2024-04-29 11:41:49
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-28 13:35:28
 * @Description: 
-->
<template>
    <div 
        class="bet-result"
        :class="{ 'result-show': showResult }"
    >
        <p class="result-coeficient">
            {{ getFixed(result?.multi) || 0 }}x
        </p>
        <p class="result-currency">
            <CurrentCoin size="24px" />
            <span class="result-balance">
                {{ getFixed(result?.winAmount) || '0.00' }}
            </span>
        </p>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
    result: {
        type: Object,
        default: () => {}
    },
    showResult: {
        type: Boolean,
        default: false
    }
})
</script>
<style lang="scss" scoped>
.bet-result {
    align-items: center;
    background: linear-gradient(180deg,#0051cb 16.13%,#489cff 83.87%);
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    height: 100px;
    justify-content: center;
    opacity: 0;
    overflow: hidden;
    padding: 15px 10px;
    top: 25%;
    transform: translate(-50%,10px);
    transition: all .3s;
    width: 200px;
    z-index: 5;
    left: 50%;
    pointer-events: none;
    position: absolute;
    &::before {
        animation: spin 24s linear infinite;
        background-image: url('@/assets/webp/coinflip/lines-bg.png');
        background-size: cover;
        content: "";
        height: 488px;
        margin-left: -244px;
        top: -50px;
        -moz-user-select: none;
        user-select: none;
        width: 488px;
        left: 50%;
        pointer-events: none;
        position: absolute;
    }
    .result-coeficient {
        font-size: 32px;
        font-weight: 700;
        line-height: 36px;
        margin-bottom: 6px;
        text-shadow: 0 5px 12px rgba(0,18,81,.4);
    }
    .result-currency {
        align-items: center;
        display: inline-flex;
        flex-shrink: 0;
        font-size: 16px;
        .result-balance {
            font-weight: 600;
            letter-spacing: -.5px;
            margin: auto 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-left: 6px;
        }
    }
}
.result-show {
    pointer-events: all;
    transform: translate(-50%);
    opacity: 1;
}
@keyframes spin {
    to {
        transform: rotate(1turn);
    }
}
</style>